<template>
    <VueDatePicker
      v-model="internalValue"
      :first-day-of-week="1"
      :locale="datepickerOptions.lang"
      :min-date="new Date()"
      :max-date="datepickerOptions.maxDate"
      :disabled-dates="disabledDatesFn"
      inline
      auto-apply
      ignore-time-validation
      :enable-time-picker="false"
      @update:model-value="select"
      cancelText="Avbryt" selectText="Välj datum"
    />
</template>

<script>
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import dayjs from "dayjs";

export default {
  components: {VueDatePicker},
  props: {
    value: {
      default: null
    },
    format: {
      default: null
    },
    lastDayNrInMonths: {
      type: Number,
      required: false,
      default: 6
    },
    buttonText: {
      type: String,
      required: false
    },
    numMonths: {
      type: Number,
      required: false,
      default: 3
    },
  },
  data() {
    return {
      internalValue: null,
      datepickerOptions: {
        highlighted: {
          dates: [new Date()],
          includeDisabled: true,
        },
        maxDate: dayjs().add(6, 'months').toDate(),
        disabledDates: function(date) {
          if (!this.lastDayNrInMonths) return false; // Ensure this exists

          const today = dayjs();
          const sixMonthsFromNow = today.add(6, "months").endOf("day");
          const givenDate = dayjs(date);

          if (givenDate.isBefore(today)) {
            return true;
          }

          let dates = [];
          for (let i = 0; i <= this.numMonths; i++) {
            dates.push(
              dayjs().add(i, "months").endOf("month").format("YYYYMMDD")
            );
          }

          return !dates.includes(givenDate.format("YYYYMMDD"));
        }
      }


    };
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        this.internalValue = value;
      }
    }
  },
  computed: {
      disabledDatesFn() {
        return (date) => {
          const today = dayjs();
          const sixMonthsFromNow = today.add(6, "months").endOf("day");
          const givenDate = dayjs(date);

          if (givenDate.isBefore(today)) {
            return true;
          }

          let dates = [];
          for (let i = 0; i <= this.numMonths; i++) {
            dates.push(dayjs().add(i, "months").endOf("month").format("YYYYMMDD"));
          }

          return !dates.includes(givenDate.format("YYYYMMDD"));
        };
      }

  },

  methods: {
    select(value) {
      this.$emit('update:modelValue', dayjs(value).format(this.format ? this.format : "YYYY-MM-DD"));
      this.$emit('close');
    },
  }
};
</script>
